(function (window, document) {
  'use strict';

  function calculatorValid() {
    return typeof window.AlwanMediaCalculator?.isValid === 'function'
      ? window.AlwanMediaCalculator.isValid()
      : false;
  }

  function termsValid() {
    return typeof window.AlwanTerms?.isValid === 'function'
      ? window.AlwanTerms.isValid()
      : Array.from(document.querySelectorAll('[data-aw-term]')).every((box) => box.checked);
  }

  function instructionsValid() {
    return typeof window.AlwanFileInstructions?.isValid === 'function'
      ? window.AlwanFileInstructions.isValid()
      : true;
  }

  function updateSubmitButtonState() {
    const button = document.querySelector('.product-form__submit');
    if (!button) return;

    button.disabled = !(calculatorValid() && termsValid() && instructionsValid());
  }

  [
    'alwan:calculator:update',
    'alwan:terms:update',
    'alwan:file-instructions:update',
    'alwan:variant:change'
  ].forEach((eventName) => {
    document.addEventListener(eventName, updateSubmitButtonState);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-form__submit');
    if (!button) return;

    window.AlwanMediaCalculator?.recalculate?.();
    updateSubmitButtonState();

    if (!termsValid()) {
      event.preventDefault();
      alert('You must acknowledge both notices before adding to cart.');
      return;
    }

    if (!instructionsValid()) {
      event.preventDefault();
      alert('Please complete the required file instruction fields before adding to cart.');
      return;
    }

    if (!calculatorValid()) {
      event.preventDefault();
      alert('Please enter a valid print size or square footage that fits the available media.');
    }
  });

  function init() {
    updateSubmitButtonState();

    const observer = new MutationObserver(() => updateSubmitButtonState());
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      observer.observe(productForm, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.updateSubmitButtonState = updateSubmitButtonState;
})(window, document);
